import { Trans as I18nTrans, useTranslation } from 'react-i18next'

export const Trans: typeof I18nTrans = ({ i18nKey, children, ...rest }) => {
  const { t } = useTranslation()
  return (
    <I18nTrans i18nKey={i18nKey} t={t} {...rest}>
      {children}
    </I18nTrans>
  )
}
